import { render, staticRenderFns } from "./riqing.vue?vue&type=template&id=08a909be&scoped=true"
import script from "./riqing.vue?vue&type=script&lang=js"
export * from "./riqing.vue?vue&type=script&lang=js"
import style0 from "./riqing.vue?vue&type=style&index=0&id=08a909be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a909be",
  null
  
)

export default component.exports